import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import ImportProcessService from "../../../Services/ImportProcess.service";
const makeSearchArgs = {
    loadOptions: (search, options) => ImportProcessService.search(Object.assign(Object.assign({}, options), { query: search })).then(({ data }) => data),
    label: "title",
    value: "id",
};
export const ImportProcessSearch = makeSearch(makeSearchArgs);
export const ImportProcessMultiSearch = makeMultiSearch(Object.assign({}, makeSearchArgs));
